import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Manage account", -1)
const _hoisted_2 = { class: "govuk-summary-list" }
const _hoisted_3 = { class: "govuk-summary-list__row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", { class: "govuk-summary-list__key" }, " Email address ", -1)
const _hoisted_5 = { class: "govuk-summary-list__value" }
const _hoisted_6 = { class: "govuk-summary-list__actions" }
const _hoisted_7 = ["href", "onClick"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Change")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " email", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "govuk-summary-list__row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", { class: "govuk-summary-list__key" }, " Password ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dd", { class: "govuk-summary-list__value" }, " ****** ", -1)
const _hoisted_14 = { class: "govuk-summary-list__actions" }
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Change")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-visually-hidden" }, " email", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Heading),
    _hoisted_1,
    _createElementVNode("dl", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("dd", _hoisted_5, _toDisplayString(_ctx.authenticatedUser.email), 1),
        _createElementVNode("dd", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: { name: 'AccountUpdateEmail', params: { back: 'Account' } },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", {
                class: "govuk-link",
                href: href,
                onClick: navigate
              }, _hoisted_10, 8, _hoisted_7)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("dd", _hoisted_14, [
          _createVNode(_component_router_link, {
            to: { name: 'AccountUpdatePassword', params: { back: 'Account' } },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", {
                class: "govuk-link",
                href: href,
                onClick: navigate
              }, _hoisted_18, 8, _hoisted_15)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}